import {GenericDao} from './generic.dao';
import {IAppConfig} from '../../store/interfaces/IAppConfig';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {LogService} from '../services/logging.service';
import {RetryHandler} from './handlers/retry.handlers';
import {DataValidator} from './validators/data.validators';

const GAPI_KEY_HEADER_NAME = 'X-IHG-MWS-API-Token';

export abstract class GapiDAO extends GenericDao {
  constructor(name: string, http: HttpClient, appConfig: IAppConfig, daoConfig: any, retryHandler: RetryHandler, dataValidator: DataValidator, log: LogService) {
    super(name, http, appConfig, daoConfig, retryHandler, dataValidator, log);
  }
  protected buildHeaders(customHeaders?: {[key: string]: string}): HttpHeaders {
    let headers: HttpHeaders = super.buildHeaders(customHeaders);
    if (this.daoConfig.apiToken) {
      headers = headers.set(GAPI_KEY_HEADER_NAME, String(this.daoConfig.apiToken));
    }
    return headers;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/gapi.dao.ts